














































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { GPageBase } from '@/mixins';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import { EvalSettingSimple, UpdateEvalSettingSimpleRequest } from '@/models/evalSetting/eval-setting-simple';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvalSettingsForAcademicSearch } from '@/models/evalSetting/eval-settings-for-academic-search';
import { masterModule } from '@/store/modules/entities/master.module';
import { QuestionType } from '@/models/evalSetting/question-type';
import { PagingData } from '@/models/core/paging-data';
import { GEnum } from '@/constants/enum.defination';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import { examCreateModule } from '@/store/modules/frames/exam-create.module';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import { DateUtils } from '@/utils/date.utils';
import GNoDataSpan from '@/components/GNoDataSpan.vue';
import GOptionalData from '@/components/GOptionalData.vue';
import GOptionalIcon from '@/components/GOptionalIcon.vue';
import GExamListActionIcons from '@/views/GExamList/GExamListActionIcons.vue';
import GExamListDeadlineInput from '@/views/GExamList/GExamListDeadlineInput.vue';
import GExamListTools from '@/views/GExamList/GExamListTools.vue';
import GExamListTitleInput from '@/views/GExamList/GExamListTitleInput.vue';
import { evalSettingListModule } from '@/store/modules/frames/eval-setting-list.module';
import GExamListTable from '@/views/GExamList/GExamListTable.vue';
import GExamListCard from '@/views/GExamList/GExamListCard.vue';
import { CompetencyType } from '@/constants/competencyType.enum';

@Component({
  name: 'GExamList',
  components: {
    GExamListCard,
    GExamListTable,
    GExamListTitleInput,
    GExamListTools,
    GExamListDeadlineInput,
    GExamListActionIcons,
    GOptionalIcon,
    GOptionalData,
    GNoDataSpan,
    GTitleBar,
    GCustomBreadCrumb,
  },
  computed: {},
  methods: {},
  validations: {},
})
export default class GExamList extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = []; // パンくずリスト
  readonly pageSizeTable: number = 15; // テーブル形式の１ページあたりの表示サイズ
  readonly pageSizeCard: number = 6; // カード形式の１ページあたりの表示サイズ
  readonly defaultPageNum: number = 1; // 初期ページ番号
  lazy: boolean = false;

  async mounted() {
    evalSettingListModule.clean();
    this.breadCrumbItems = [{ title: this.$t('HOME').toString(), icon: 'ios-home', routerPath: '/pages/home' }, { title: this.$t('MENU_EVAL_COURSE').toString() }];
    this.fetchEvalSettings(this.defaultPageNum);
    await masterModule.fetchQuestionType();
    this.lazy = true;
  }

  get pageSize() {
    return this.viewMode === 1 ? this.pageSizeTable : this.pageSizeCard;
  }

  get viewMode(): number {
    return evalSettingListModule.viewMode;
  }

  get currentPageNum(): number {
    return evalSettingListModule.currentPageNum;
  }

  get questionTypes(): QuestionType[] {
    return masterModule.questionTypes;
  }

  get evalSettingSimples(): PagingData<EvalSettingSimple> {
    if (evalSettingModule.evalSettingSimples === undefined) {
      return new PagingData<EvalSettingSimple>();
    }
    if (evalSettingModule.evalSettingSimples.data && evalSettingModule.evalSettingSimples.totalRecords < this.pageSizeTable) {
      for (let i = 0; i < this.pageSizeTable - evalSettingModule.evalSettingSimples.totalRecords; i++) {
        evalSettingModule.evalSettingSimples.data.push(new EvalSettingSimple().deserialize({ evalSettingID: -1 }));
      }
    }
    return evalSettingModule.evalSettingSimples;
  }

  handleToEvalSettingDetail(evalSettingID: number) {
    this.$router.push(`/pages/exam/${evalSettingID}?mode=${GEnum.EvalSettingMode.Detail}`);
  }

  handleUpdateTitle(evalSettingSimple: EvalSettingSimple, beforeTitle: string) {
    this.updateEvalSettingSimple(evalSettingSimple, () => {
      this.showNotice(GEnum.MessageType.Success, this.$t('UPDATE_EVAL_COURSE_NAME').toString(), this.$t('BEFORE_EDIT').toString() + ` : ${beforeTitle}<br/>` + this.$t('AFTER_EDIT').toString() + ` : ${evalSettingSimple.title}`);
      this.fetchEvalSettings(this.currentPageNum);
    });
  }

  handleUpdateStartTime(evalSettingSimple: EvalSettingSimple, beforeStartTime: Date) {
    this.updateEvalSettingSimple(evalSettingSimple, () => {
      this.showNotice(
        GEnum.MessageType.Success,
        this.$t('EVAL_COURSE').toString() + `【${evalSettingSimple.title}】<br/>` + this.$t('UPDATE_START_DATE').toString(),
        this.$t('BEFORE_EDIT').toString() + ` : ${DateUtils.changeFormatDateTime(beforeStartTime)}<br/>` + this.$t('AFTER_EDIT').toString() + ` : ${DateUtils.changeFormatDateTime(evalSettingSimple.startTime)}`
      );
      this.fetchEvalSettings(this.currentPageNum);
    });
  }

  handleUpdateDeadline(evalSettingSimple: EvalSettingSimple, beforeDeadline: Date) {
    this.updateEvalSettingSimple(evalSettingSimple, () => {
      this.showNotice(
        GEnum.MessageType.Success,
        this.$t('EVAL_COURSE').toString() + `【${evalSettingSimple.title}】<br/>` + this.$t('CHANGE_EVAL_COURSE_END').toString(),
        this.$t('BEFORE_EDIT').toString() + ` : ${DateUtils.changeFormatDateTime(beforeDeadline)}<br/>` + this.$t('AFTER_EDIT').toString() + ` : ${DateUtils.changeFormatDateTime(evalSettingSimple.deadline)}`
      );
      this.fetchEvalSettings(this.currentPageNum);
    });
  }

  // コース名and開始日and終了日 更新
  updateEvalSettingSimple(evalSettingSimple: EvalSettingSimple, after: () => void) {
    const updateEvalSettingSimpleRequest: UpdateEvalSettingSimpleRequest = {
      evalSettingID: evalSettingSimple.evalSettingID,
      title: evalSettingSimple.title,
      startTime: evalSettingSimple.startTime,
      deadline: evalSettingSimple.deadline,
    };

    this.loadingPage(
      () => {
        evalSettingListModule.updateEvalSettingSimple(updateEvalSettingSimpleRequest);
      },
      after,
      500
    );
  }

  // ページ切り替え
  handlePagerChange(pageNum: number) {
    evalSettingListModule.setCurrentPageNum(pageNum);
    this.fetchEvalSettings(pageNum);
  }

  // コース取得
  fetchEvalSettings(pageNum: number) {
    evalSettingModule.fetchEvalSettingSimples({
      limit: this.pageSize,
      offset: this.pageSize * (pageNum - 1),
      hasStatusCompleted: this.convertRadioToBoolean(evalSettingListModule.hasStatusCompleted),
    } as EvalSettingsForAcademicSearch);
  }

  // レポートリンク更新
  updateReportLink(evalSettingSimple: EvalSettingSimple) {
    const updateEvalSettingSimpleRequest: UpdateEvalSettingSimpleRequest = {
      evalSettingID: evalSettingSimple.evalSettingID,
      title: evalSettingSimple.title,
      startTime: evalSettingSimple.startTime,
      deadline: evalSettingSimple.deadline,
    };
    evalSettingModule.setSelectedItem(evalSettingSimple.selectedReportLink);
    evalSettingModule.updateReportLink(updateEvalSettingSimpleRequest);

    var newSelectValue = CompetencyType.personalReportType(evalSettingSimple.selectedReportLink);
    var oldSelectValue = evalSettingSimple.reportEnabled
      ? CompetencyType.personalReportType(evalSettingSimple.reportDisplayType)
      : CompetencyType.personalReportType(GEnum.PersonalReportDisplayType.NoShow);

    // 成功時のメッセージ
    this.showNotice(GEnum.MessageType.Success, this.$t('UPDATE_REPORT_LINK').toString(), this.$t('EVAL_COURSE_NAME').toString() + ` : ${evalSettingSimple.title}<br/>` + this.$t('BEFORE_EDIT').toString() + ` : ${oldSelectValue}<br/>` + this.$t('AFTER_EDIT').toString() + ` : ${newSelectValue}`);

    // evalSettingSimple を更新する
    evalSettingSimple.reportDisplayType = evalSettingModule.reportDisplayType;
    evalSettingSimple.reportEnabled = evalSettingModule.reportEnabled;
  }
}
